import React, { ClipboardEventHandler, useEffect, useState } from 'react';
import { Animate } from '../../animation/animation';
import cn from 'classnames';

import styles from './input-field.module.scss';
import { IMaskInput } from 'react-imask';
import { ReactElement } from 'react-imask/dist/mixin';

interface InputFieldProps {
  name: string;
  value: any;
  label?: string;
  mask: string;
  theme?: string;
  onChange?: (value: any) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  onPaste?: ClipboardEventHandler<ReactElement>
  placeholder?: string;
  type?: string;
  autoComplete?: string;
  inputType?: {
    padding?: string;
    border?: string;
    font_size?: string;
  }
  noMargin?: boolean;
}

export function InputField(props: React.PropsWithChildren<InputFieldProps>) {
  const { onChange, name, theme, inputType, label, children, noMargin, ...rest } = props;
  const [styleClasses, setStyleClasses] = useState([styles[theme || 'default'], styles[name]]) 

  useEffect(() => {
    const { padding, border, font_size } = inputType || {};

    if (padding !== "DEFAULT" || border !== "DEFAULT" || font_size !== "DEFAULT") {
      setStyleClasses(prevState => [...prevState, styles[padding || ""], styles[border || ""], styles[font_size || ""]]);
    }

  }, [inputType]);

  return (
    <Animate name="field" effect={styles.active} when={true}>
      <div className={cn(...styleClasses, { [styles.noMargin]: noMargin })}>
        {(styleClasses.includes(styles.border) && label) && <label className={styles.label}>{label}</label>}
        {children ? children : <IMaskInput 
          id={name}
          name={name}
          value={rest.value}
          mask={rest.mask}
          placeholderChar={"_"}
          lazy={false}
          placeholder={rest.placeholder}
          type={rest.type}
          autoComplete={rest.autoComplete}
          onPaste={rest.onPaste}
          onAccept={(value, ref) => onChange && onChange(value)}
          />}
      </div>
    </Animate>
  )
}